var CaptchaService = (function () {

    'use strict';

    //************ Variables ************//
    var siteKey = '6LeWStwZAAAAAC21doBZPiO-AkOzpYAxwFvscqfE';

    //************ Functions ************//
    function render(element) {

        return grecaptcha.render(element, {
            'sitekey': siteKey,
            'size' : (window.innerWidth < 410? 'compact' : 'normal')
        });
    }

    //************ Public ************//
    return {
        render: render
    };
})();
